var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "100%",
    height: "100%",
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#36bd4e",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendmode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.73828,5.99414c-0.32482,0.00981 -0.63305,0.14571 -0.85937,0.37891l-10.87891,10.86133l-4.88477,-4.87305c-0.31389,-0.32618 -0.77958,-0.45719 -1.2175,-0.34251c-0.43791,0.11468 -0.77961,0.45714 -0.89333,0.8953c-0.11372,0.43816 0.01832,0.90357 0.3452,1.21674l5.76758,5.75391c0.48794,0.48666 1.27769,0.48666 1.76563,0l11.76172,-11.74414c0.36977,-0.35907 0.48127,-0.90827 0.28079,-1.3831c-0.20048,-0.47484 -0.67183,-0.77796 -1.18704,-0.76338z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2ea34f716051fbb1903b8198467f3793.svg";
export { ForwardRef as ReactComponent };